import React from 'react';
import Svg from '../icons/svg';

function ShareButton(props) {
  const { social, path } = props;
  const socialList = {
    twitter: {
      icon: <Svg name={'twitter'} fill={'#262626'} width={24} height={24} label={'Share to twitter'} />,
      title: 'توییتر',
      link: `https://twitter.com/share?text=${window.location.hostname}/${path}`,
    },
    mail: {
      icon: <Svg name={'mail'} fill={'#262626'} width={24} height={24} label={'Share via mail'} />,
      title: 'ایمیل',
      link: `mailto:?subject=این صفحه را نگاه کن&body=${window.location.hostname}/${path}`,
    },
  };
  const data = socialList[social];

  if (!data) {
    return null;
  }

  return (
    <a className="c-p" href={data.link} target="_blank" rel="noopener noreferrer">
      <div className="py-8p px-16p f-row f-00auto justify-content-start align-items-center align-content-stretch bg-hover-dark-10">
        <div className="ml-12p f-00auto align-items-stretch align-content-stretch">
          <div className="wh-32p align-items-center justify-content-center">{data.icon}</div>
        </div>
        <div className="min-wh-0 f-11auto justify-content-center align-content-stretch align-items-stretch">
          <div className="font-size-5 f-row align-items-center justify-content-start color-main">{data.title}</div>
        </div>
      </div>
    </a>
  );
}

export default ShareButton;
